import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuditItemModel } from '../audit-item.model';
import { UtilsService } from 'src/app/shared/utils.service';
import { ActivatedRoute } from '@angular/router';
import { AuditItemsService } from '../audit-items.service';
import { RBACService } from 'src/app/shared/rbac.service';

@Component({
  selector: 'app-audit-items-template-view',
  templateUrl: './audit-items-template-view.component.html',
  styleUrls: ['./audit-items-template-view.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuditItemsTemplateViewComponent implements OnInit {
  auditItem = new AuditItemModel();

  constructor(
    public utils: UtilsService,
    private activatedRoute: ActivatedRoute,
    private auditItemService: AuditItemsService,
    public location: Location,
    public rbac: RBACService
  ) {}

  ngOnInit() {
    // 1. Check view permission: redirect back if denied.
    const canView = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_TEMPLATES_INSPECTIONS_AUDITS,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    if (!canView) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to view inspection/audit questions.'
      );
      this.location.back();
      return;
    }

    // 2. Load question data.
    this.auditItem.id = Number(this.activatedRoute.snapshot.params['id']);
    this.auditItemService
      .find(this.auditItem.id)
      .subscribe((response) => (this.auditItem = response.data));
  }
}
